import { documentId, getDocs, query, where } from 'firebase/firestore';
import { allClassNumbers } from '../helpers/academic-years';
import { CategoriesOrder } from '../types/categories-order';
import BaseService from './base-service';

class CategoriesService extends BaseService<CategoriesOrder> {
  private batchSize = 10;

  constructor() {
    super('categoriesorder');
  }

  async getUniversal(): Promise<CategoriesOrder | null> {
    return await super.get('universal');
  }

  async getBySubjectIdAndYear(
    subjectId: string,
    year: number
  ): Promise<CategoriesOrder | null> {
    return await super.get(
      subjectId === '' ? 'universal' : `${year}${subjectId}`
    );
  }

  async getBySubjectId(subjectId: string): Promise<CategoriesOrder[]> {
    const categoriesOrders: CategoriesOrder[] = [];
    const ids = allClassNumbers.map(
      (classNumber) => `${classNumber}${subjectId}`
    );

    for (let i = 0; i < ids.length; i += this.batchSize) {
      const batchIds = ids.slice(i, i + this.batchSize);
      const q = query(this.collectionRef, where(documentId(), 'in', batchIds));
      const snapshot = await getDocs(q);

      ids.forEach((id) => {
        const doc = snapshot.docs.find((doc) => doc.id === id);
        if (doc)
          categoriesOrders.push({
            id: doc.id,
            ...(doc.data() as CategoriesOrder),
          });
      });
    }

    return categoriesOrders;
  }

  async updateBySubjectIdAndYear(
    subjectId: string,
    year: number,
    categoriesOrder: CategoriesOrder
  ): Promise<void> {
    return await super.update({
      id: subjectId === '' ? 'universal' : `${year}${subjectId}`,
      ...categoriesOrder,
    });
  }
}

const categoriesOrderService = new CategoriesService();
export default categoriesOrderService;
